<template>
    <div class="container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
            <breadcrumb :breadcrumbConfig="dataList"></breadcrumb>
        </div>
        <!-- 查询客户列表 -->
        <div class="table">
            <div class="btnBox">
                <el-form :inline="true" ref="form" :model="queryForm" label-width="" size="mini">
                    <el-form-item>
                        <div class="input-with-select">
                            <div style="display: flex; align-items: center; width: 220px;">
                                <el-select v-model="queryForm.searchType" placeholder="请选择" clearable
                                    style="width: 110px;" class="category-select">
                                    <el-option label="退货单号" value="returnOrderNo" class="category-option"></el-option>
                                    <el-option label="关联采购单号" value="purchaseOrderNo"
                                        class="category-option"></el-option>
                                </el-select>
                                <el-input placeholder="请输入" v-model="queryForm.searchKeyword"></el-input>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <div class="input-with-select">
                                <span class="prepend-text">供应商名称</span>
                                <el-input placeholder="请输入" v-model="queryForm.supplierName"></el-input>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">退货单状态</span>
                            <el-select v-model="queryForm.info" placeholder="请选择" clearable default-first-option>
                                <el-option v-for="(items, index) in dictionaries.new_purchase_return_order_status"
                                    :key="items.dictId" :label="items.dictName" :value="items.dictId"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">退货员</span>
                            <el-select v-model="queryForm.receivers" placeholder="请选择接收人员"
                                @click.native="openUserPicker" class="select-u" collapse-tags multiple
                                popper-class="hidden">
                                <el-option v-for="(user, index) in queryForm.receivers" :key="index" :label="user.name"
                                    :value="user">
                                </el-option>
                            </el-select>
                        </div>

                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">退货商品</span>
                            <el-input placeholder="请输入" v-model="queryForm.brand"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchEvent()"
                            v-on:keyup.enter="searchEvent">查询</el-button>
                        <el-button plain size="mini" @click="reset">重置</el-button>
                    </el-form-item>
                    <el-form-item class="form-buttons" style="width: 100%;">
                        <div class="button-container">
                            <div class="button-group left-group">
                                <el-button style="background-color: #fff;" @click="handleAdd" plain size="mini"
                                    v-if="parArray.indexOf('purchase-return-add') != -1">
                                    <span style="display: flex; align-items: center">
                                        新增退货单
                                    </span>
                                </el-button>
                                <el-dropdown @command="handleExportCommand"
                                    v-if="parArray.indexOf('purchase-return-export') != -1">
                                    <el-button plain size="mini">
                                        导 出<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="exportAll">
                                            导出列表
                                        </el-dropdown-item>
                                        <el-dropdown-item :disabled="!hasSelection" command="exportSelected"
                                            :class="{ 'is-disabled': !hasSelection }">
                                            导出本页勾选的数据
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="button-group right-group">
                                <el-checkbox v-model="autoRefresh" @change="handleAutoRefreshChange">
                                    自动刷新页面
                                </el-checkbox>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div style="padding: 0 10px;background-color: #fff;margin: 0 -10px;" v-loading="loading">
                <lb-table v-horizontal-scroll='"always"' border :column="columns" align="center" :data="tableData.list"
                    pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="page.currentPage"
                    :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange"
                    @refresh="fetchData" :orderStatistics="page.totalNum" statisticText="当前列表统计总采购订单数"
                    @selection-change="handleSelectionChange">
                </lb-table>
            </div>
        </div>
        <purchase-order :visible="goodsSelectorVisible" @update:visible="goodsSelectorVisible = $event"
            @selected="handleGoodsSelected"></purchase-order>
        <!-- 采购订单对话框组件 -->
        <purchase-order-dialog :visible="dialogVisible" :type="dialogType" :form-data="formLabel"
            :selected-purchase-orders="selectedGoods" @update:visible="dialogVisible = $event"
            @submit="handleOrderSubmit" @success="handleDialogSuccess" @closed="resetForm">
        </purchase-order-dialog>
        <org-picker title="接收人员" :multiple="false" ref="orgPicker" @ok="selectedUser" />
    </div>
</template>

<script>
import vueEasyPrint from "vue-easy-print";
import breadcrumb from "@/components/breadcrumb.vue";
import * as imageConversion from 'image-conversion';
import LbTable from '@/pages/purchase/components/lb-table/lb-table'
import OrgPicker from "@/components/OrgPicker.vue";
import PurchaseOrderDialog from './add.vue'; // 引入采购订单对话框组件
import PurchaseOrder from '@/pages/purchase/components/common/PurchaseOrder.vue'; // 选择退货采购订单对话框组件

export default {
    components: {
        vueEasyPrint, breadcrumb, LbTable, OrgPicker, PurchaseOrderDialog, PurchaseOrder
    },
    data() {
        // 添加供应商表单验证规则
        const validateSupplierName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入供应商名称'));
            } else {
                callback();
            }
        };
        return {
            dataList: {
                list: [
                    { title: '采购管理', type: 0, path: '' },
                    { title: '采购退货列表', type: 1, path: '/purchase/supplierList' }
                ],
            },
            // 新增数据属性
            goodsSelectorVisible: false, // 选择商品弹框显示控制
            selectedGoods: [], // 选择从商品选择器选中的商品

            supplierOptions: [], // 供应商选项列表
            skus: [],
            brands: [],
            show3: false,
            imgDialogVisible: false,
            moreImg: "",
            queryForm: {
                info: "",
                supplierName: "",
                founder: "",
                address: "",
                brand: "",
                date: "",
                searchType: "returnOrderNo", // 默认搜索类型
                searchKeyword: "", // 搜索关键词
                receivers: [],
                returnerId: null, // 退货员ID
            },
            dialogVisible: false, // 弹框显示控制
            dialogType: 'add', // 弹框类型: add-新增, edit-编辑, view-查看
            pageNo: 1,
            pageSize: 10,
            brandselect: [],
            options: [],
            upplier: [],
            mulvaltipleSelection: [], // 当前页勾选的数据
            parArray: [],
            moreProdMaterialText: "",
            isMoreProdMaterial: false,
            fileListImg: [],
            supplierNames: [],
            goodNames: [],
            multipleSelection: [],
            goodsObj: [],
            specificationList: [],
            dictionaries: { // 字典数据
                goods_type: [], // 商品类型
                new_purchase_return_order_status: [], // 采购退货单状态
            },
            brandId: '',
            // 分类类型选项
            categoryTypes: [
                { label: '采购单状态', value: 'purchaseStatus' },
                { label: '入库状态', value: 'storageStatus' },
                { label: '审批单来源', value: 'approvalSource' }
            ],

            // 各分类类型对应的枚举值
            categoryValues: {
                purchaseStatus: [
                    { label: '草稿', value: 'draft' },
                    { label: '作废', value: 'invalid' },
                    { label: '已生效', value: 'effective' }
                ],
                storageStatus: [
                    { label: '未入库', value: 'notStorage' },
                    { label: '部分入库', value: 'partStorage' },
                    { label: '已入库', value: 'allStorage' }
                ],
                approvalSource: [
                    { label: '综合', value: 'comprehensive' },
                    { label: '非综合', value: 'notComprehensive' }
                ]
            },

            // 当前选中的分类值列表
            currentCategoryValues: [],
            loading: false,
            autoRefresh: false,// 是否自动刷新
            refreshTimer: null, // 定时器
            // 表单数据
            formLabel: {
                id: '', // 供应商ID
                supplierName: '', // 供应商名称
                supplierCategory: '', // 供应商分类
                linkName: '', // 联系人
                phone: '', // 联系号码
                email: '', // 邮箱地址
                settlementPeriod: '', // 结算期限
                creditLimit: null, // 信用额度
                invoiceTitle: '', // 发票抬头
                bankName: '', // 开户银行
                accountNumber: '', // 收款账号
                address: '', // 供应商地址
                remarks: '' // 备注
            },
            page: {
                pageNo: 1,
                pageSize: 10,
                totalNum: 0
            },
            tableData: {
                list: [],
                totalNum: 0
            },
            // 表单验证规则
            rules: {
                supplierName: [
                    { required: true, validator: validateSupplierName, trigger: 'blur' }
                ]
            },
            columns: [
                { type: 'selection', width: '30' },
                {
                    label: '序号', prop: 'index', width: '50',
                    render: (h, scope) => {
                        const index = (this.page.currentPage - 1) * this.page.pageSize + scope.$index + 1;
                        return h('div', index);
                    }
                },
                {
                    label: '退货单号', prop: 'returnOrderNo', width: '120',
                    render: (h, scope) => {
                        const returnOrderNo = scope.row.returnOrderNo;
                        if (!returnOrderNo) {
                            return h('div', '-')
                        }

                        return h('div', [
                            h('el-tooltip', {
                                props: {
                                    content: '点击复制',
                                    placement: 'top'
                                }
                            }, [
                                h('span', {
                                    class: 'copyable-text',
                                    style: {
                                        cursor: 'pointer',
                                    },
                                    on: {
                                        click: (e) => {
                                            e.stopPropagation();
                                            this.copyToClipboard(returnOrderNo);
                                        }
                                    }
                                }, returnOrderNo)
                            ])
                        ])
                    }
                },
                { label: '退货类型', prop: 'returnTypeLabel', minWidth: '100' },
                { label: '关联采购单号', prop: 'purchaseOrderNo', minWidth: '160' },
                { label: '退货地址', prop: 'returnAddress', minWidth: '160' },
                {
                    label: '采购退货数量', prop: 'totalReturnQuantity', minWidth: '102',
                },
                {
                    label: '退货金额（元）', prop: 'totalReturnAmount', width: '100',
                },
                {
                    label: '供应商名称', prop: 'supplierName', width: '151',
                    render: (h, scope) => {
                        return (
                            <div class='ellipsis2' title={scope.row.supplierName}>{scope.row.supplierName ? scope.row.supplierName : "-"}</div>
                        )
                    }
                },
                {
                    label: '退货单状态', prop: 'statusLabel', width: '100',
                },

                {
                    label: '退货商品', prop: 'returnGoods', width: '100',
                },
                {
                    label: '创建日期', prop: 'createdTime', minWidth: '100',
                },
                {
                    label: '修改日期', prop: 'updatedTime', minWidth: '100',
                },
                {
                    label: '退货单创建人', prop: 'createdByName', minWidth: '100',
                },
                {
                    label: '退货员', prop: 'returnerName', minWidth: '100',
                },
                {
                    label: '操作',
                    prop: 'orgName',
                    minWidth: '150',
                    fixed: "right",
                    render: (h, scope) => {
                        const isDraft = scope.row.status === 0; // 草稿状态

                        return (
                            <div style="display:flex;justify-content:center">
                                <el-button type="text" style="color:#409EFF;margin-right:8px" onClick={() => { this.handleEdit(scope.row) }}>查看/编辑</el-button>
                                {
                                    // 只有草稿状态才显示删除按钮
                                    isDraft && (
                                        <el-button type="text" onClick={() => { this.handleDelete(scope.row) }}>删除</el-button>
                                    )
                                }
                            </div>
                        )
                    }
                }
            ],
        };
    },

    computed: {
        // 计算弹窗标题
        dialogTitle() {
            const titles = {
                'add': '新增供应商',
                'edit': '编辑供应商',
            };
            return titles[this.dialogType];
        },
        // 是否有选中的数据
        hasSelection() {
            return this.mulvaltipleSelection.length > 0;
        }
    },

    created() {
        // 权限设定判断
        let limits = JSON.parse(sessionStorage.getItem("limit"));
        const params = limits.buttonTreeDto.filter(
            (item) => item.menuCode === "purchaseReturnList"
        );
        params[0].buttonList.forEach((item) => {
            this.parArray.push(item.code);
        });
        // 权限设定判断
        this.brandSelectBox();
        this.brandSelect();
        this.listAxios();
        this.upplierAxios();
        this.specificationSelect();
        this.loadSupplierOptions();

        let _this = this;
        document.onkeydown = function (e) {
            let key = window.event.keyCode;
            if (key == 13) {
                _this.searchEvent();
            }
        };
        this.getMultipleDictionaries(['goods_type', 'new_purchase_return_order_status'])
        this.currentCategoryValues = this.categoryValues.purchaseStatus;
    },
    beforeRouteLeave(to, form, next) {
        document.onkeydown = null;
        next();
    },
    beforeDestroy() {
        //组件销毁前清除定时器
        this.stopAutoRefresh();
    },
    methods: {
        // 处理表格选择变化
        handleSelectionChange(selection) {
            this.mulvaltipleSelection = selection;
        },

        // 处理导出命令
        handleExportCommand(command) {
            // 检查权限
            if (this.parArray.indexOf('purchase-return-export') === -1) {
                this.$message.warning('您没有导出权限');
                return;
            }

            if (command === 'exportAll') {
                this.exportAllData();
            } else if (command === 'exportSelected') {
                if (!this.hasSelection) {
                    this.$message.warning('请先勾选要导出的退货单');
                    return;
                }
                this.exportSelectedData();
            }
        },

        // 导出所有数据（包括翻页）
        exportAllData() {
            const exportParams = {
                ids: [],
                pageNo: 1,
                pageSize: 100000
            };
            this.$api.srmReturnOrderExport(exportParams).then(res => {
                if (res.code === 0) {
                    this.downloadlink(res.data);
                    this.$message.success('导出成功');
                } else {
                    this.$message.error(res.message || '导出失败');
                }
            }).catch(error => {
                this.$message.error('导出失败');
                console.error('Export error', error);
            })
        },

        exportSelectedData() {
            const exportParams = {
                ids: this.mulvaltipleSelection.map(item => item.id),
                exportAll: false,
            }
            this.$api.srmReturnOrderExport(exportParams).then(res => {
                if (res.code === 0) {
                    this.downloadlink(res.data);
                    this.$message.success('导出成功');
                } else {
                    this.$message.error(res.message || '导出失败');
                }
            }).catch((error) => {
                this.exportLoading = false;
                this.$message.error('导出失败，请重试');
                console.error('Export error:', error);
            });
        },

        // 复制文本到剪贴板
        copyToClipboard(text) {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            if (successful) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }

            document.body.removeChild(textArea);

        },
        handleAdd() {
            this.dialogType = 'add';
            this.formLabel = { id: null };

            // 先打开商品选择对话框
            this.goodsSelectorVisible = true;
            this.selectedGoods = [];
        },

        // 处理退货订单选择
        handleGoodsSelected(selectedGoods) {
            console.log('接收到选中的采购订单:', selectedGoods);
            this.selectedGoods = selectedGoods;

            // 关闭商品选择对话框
            this.goodsSelectorVisible = false;

            // 打开采购订单对话框，并传递选中的采购订单数据
            this.dialogVisible = true;
        },

        // 处理对话框关闭 - 新增方法
        handleDialogClosed() {
            this.dialogVisible = false;
            // 可以选择是否清空选中的商品
            // this.selectedGoods = [];
        },

        // 编辑/查看供应商
        handleEdit(row) {
            this.dialogType = 'edit'; // 默认进入查看模式
            // this.fillFormData(row);
            // 只传递订单ID，而不是填充所有表单数据
            this.formLabel = { id: row.id }
            this.dialogVisible = true;
        },

        handleDialogSuccess() {
            this.listAxios();
        },


        //处理采购订单提交
        handleOrderSubmit(formData) {
            if (this.dialogType === 'add') {
                this.addOrder(formData);
            } else if (this.dialogType === 'edit') {
                this.updateOrder(formData);
            }
        },

        // 新增采购订单
        addOrder(formData) {
            this.$api.purchaseOrderAdd(formData).then(res => {
                if (res.code === 0) {
                    this.$message.success('新增成功');
                    this.dialogVisible = false;
                    this.listAxios();
                } else {
                    this.$message.error(res.message);
                }
            })
        },

        // 更新采购订单
        updateOrder(formData) {
            this.$api.purchaseOrderEdit(formData)
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('更新成功');
                        this.dialogVisible = false;
                        this.listAxios();
                    } else {
                        this.$message.error(res.message);
                    }
                })
        },



        // 删除供应商
        handleDelete(row) {
            // 检查状态，只有草稿状态才能删除
            if (row.status !== 0) {
                this.$message.warning('只有草稿状态的退货单才能删除');
                return;
            }

            this.$confirm('确定要删除该采购退货单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteReturnOrder(row.id);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 删除api调用
        deleteReturnOrder(id) {
            this.$api.srmReturnOrderDelete({ id: id })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('删除成功');
                        this.listAxios();
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        // 填充表单数据
        fillFormData(row) {
            this.formLabel = {
                id: row.id,
                orderNumber: row.orderNumber,
                supplierId: row.supplierId,
                orderDate: row.orderDate,
                expectedDate: row.expectedDate,
                status: row.status,
                items: row.items || [],
                remarks: row.remarks
            };
        },

        // 重置表单
        resetForm() {
            this.formLabel = {
                id: null,
                orderNumber: '',
                supplierId: '',
                orderDate: '',
                expectedDate: '',
                status: 'draft',
                items: [],
                remarks: ''
            };
        },

        // 加载供应商选项
        loadSupplierOptions() {
            const params = {};
            this.$api.srmSupplierList(params).then(res => {
                if (res.code === 0) {
                    this.supplierOptions = res.data;
                }
            });
        },

        // 删除供应商
        deleteSupplier(id) {
            this.axios.post('/order/v1/purchase/supplier/delPurchaseSupplier', [id])
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('删除成功');
                        this.listAxios();
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error('删除失败');
                    console.error(err);
                });
        },

        //打开人员选择器
        openUserPicker() {
            this.$refs.orgPicker.show(this.queryForm.receivers, 'user');
        },
        //人员选择回调
        selectedUser(data) {
            this.queryForm.receivers = data;
            this.queryForm.returnerId = data[0].id;
        },
        // 处理自动刷新状态变化
        handleAutoRefreshChange(isChecked) {
            if (isChecked) {
                this.startAutoRefresh();
            } else {
                this.stopAutoRefresh();
            }

        },

        // 启动自动刷新
        startAutoRefresh() {
            //清除可能存在的旧定时器
            this.stopAutoRefresh();

            //设置新定时器，5分钟
            this.refreshTimer = setInterval(() => {
                this.$message.info("刷新中...");
                this.listAxios();
            }, 300000);
        },

        // 停止自动刷新
        stopAutoRefresh() {
            if (this.refreshTimer) {
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            }
        },

        handleCategoryTypeChange(value) {
            this.queryForm.categoryValue = "";
            this.currentCategoryValues = value ? this.categoryValues[value] : [];
        },



        handleType(val) {
            for (let i = 0; i < this.dictionaries.goods_type.length; i++) {
                if (this.dictionaries.goods_type[i].dictId == val) {
                    return this.dictionaries.goods_type[i].dictName
                }
            }
        },
        fetchData() {
            this.listAxios();
        },
        // 提交表单
        submitForm() {
            this.$refs.supplierForm.validate((valid) => {
                if (valid) {
                    if (this.dialogType === 'add') {
                        this.add();
                    } else if (this.dialogType === 'edit') {
                        this.update();
                    }
                } else {
                    this.$message.error('请填写必填项');
                    return false;
                }
            });
        },

        // 更新供应商信息
        update() {
            this.axios.post('/order/v1/purchase/supplier/updatePurchaseSupplier', this.formLabel)
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('更新成功');
                        this.dialogVisible = false;
                        this.listAxios();
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error('更新失败');
                    console.error(err);
                });
        },
        // 批量获取需要的字典数据
        getMultipleDictionaries(types) {
            types.forEach((type) => {
                this.getDictionaries(type);
            });
        },
        // 获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) { return }
            const params = { groupId: type }
            this.$api.dictionaries(params).then((res) => {
                this.dictionaries[type] = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        tpPrintJS() {
            if (this.mulvaltipleSelection.length < 1) {
                this.$message.warning("请选择");
                this.value = "";
                return;
            }
            this.$refs.easyPrint.print();
        },
        //启用
        startUsing(id) {
            this.$confirm("确定要启用吗?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }).then(({ value }) => {
                this.axios
                    .post("order/v1/purchase/supplier/confirmPurchaseSupplier", {
                        ids: [id],
                        supplierStatus: "2",
                    })
                    .then((res) => {
                        if (res.code == 0) {
                            this.$message.success("启用成功");
                            this.listAxios();
                        } else {
                            this.$message.error(res.message);
                        }
                    });
            });
        },
        //商品规格
        specificationSelect() {
            this.axios.get("/order//comm/commDictonary/list").then((res) => {
                if (res.code == 0) {
                    this.specificationList = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getGoodNames(n) {
            this.axios
                .post(
                    "/goods/goods/getGoodsIds",
                    {
                        pageNo: 1,
                        pageSize: 200000,
                        title: n,
                        type: this.formLabel.type,
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    this.goodsObj = res.data;
                    this.goodNames = res.data.map((item) => item.name);
                });
        },
        imgUpload(fileObj) {
            let length = this.fileListImg.length;
            let formData = new FormData();
            formData.append("file", fileObj.file);

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };
            if (length <= 20) {
                this.axios
                    .post(
                        "/sys/v1/common/upload/files?pathName=internalSystem",
                        formData,
                        config,
                        {
                            headers: {
                                isLoading: false,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.code == 0) {
                            // this.imageUrl = res.data.url;
                            let obj = {
                                img: res.data.url,
                                creattime: new Date().toLocaleDateString(),
                            };
                            this.fileListImg.push(obj);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
            } else {
                this.$message.warning("图片条数不能超过20条");
            }
        },
        test(file, fileList) {
            this.$message.warning(
                "图片最多10张,现在已上传" + this.fileListImg.length + "张"
            );
        },
        goodNameSelect(e) {
            let goodObj = this.goodsObj.find((res) => res.name == e);
            this.formLabel.supplierName = e;
            console.log(goodObj);
            let data = {
                id: goodObj.id
            }
            this.axios.post("/goods/goods/getSkuList", data).then((res) => {
                if (res.code == 0) {
                    this.skus = res.data.skuList;
                    this.formLabel.brand = res.data.brandName
                    this.brandId = res.data.brandId
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        remoteMethod(e) {
            this.getGoodNames(e);
        },
        /**
        * @name: 选择商品类型触发
        * @test: test font
        * @msg:
        * @param {*} e:回调选择的value
        * @return {*}
        */
        onChange(e) {
            this.formLabel.type = e;
            this.$set(this.formLabel, "supplierName", "");
            this.goodNames = [];
        },
        supplierSelect(e) {
            let tempIf = 0;
            if (e.length) {
                if (this.supplierObjs.length) {
                    let obj = this.supplierObjs.find((res) => res.supplierName == e);
                    this.formLabel = {
                        supplier: e,
                        linkName: obj.supplierContactPerson,
                        phone: obj.supplierPhone,
                        address: obj.supplierAddress,
                        type: "",
                        brand: "",
                        guige: "",
                        price: "",
                        material: "",
                        supplierName: "",
                    };
                } else {
                    tempIf = 1;
                    this.formLabel.supplier = e;
                    this.$message.warning("这个是新创建的!");
                }
            } else {
                tempIf = 1;
            }

            if (tempIf == 1) {
                this.formLabel = {
                    supplier: this.formLabel.supplier,
                    linkName: "",
                    phone: "",
                    address: "",
                    type: "",
                    brand: "",
                    guige: "",
                    price: "",
                    material: "",
                    supplierName: "",
                };
            }
        },
        remoteSMethod(e) {
            this.axios
                .post("/order/v1/purchase/supplier/purchaseSupplierList", {
                    pageNo: 1, //第几页
                    pageSize: 20000, //一页多少条
                    supplierStatus: 1, //	未确认列表1 或者是 确认列表 2
                    supplierName: e,
                })
                .then((res) => {
                    this.supplierNames = res.data.list.map((i) => i.supplierName);
                    this.supplierObjs = res.data.list;
                });
        },
        beforeUploadImg(file) {
            return new Promise((resolve, reject) => {
                let _URL = window.URL || window.webkitURL;
                let isLt2M = file.size / 1024 / 1024 > 4; // 判定图片大小是否小于4MB
                // 这里需要计算出图片的长宽
                let img = new Image();
                img.onload = function () {
                    file.width = img.width; // 获取到width放在了file属性上
                    file.height = img.height; // 获取到height放在了file属性上
                    let valid = img.width > 10000; // 图片宽度大于2000
                    // console.log(11, file)
                    // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
                    if (valid || isLt2M) {
                        imageConversion.compressAccurately(file, {
                            size: 400,
                            width: 2000,
                        })
                            .then((res) => {
                                // console.log(33, res)
                                resolve(res);
                                this.$message.success(
                                    "成功添加" + this.fileList.length + "张图片"
                                );
                            });
                    } else resolve(file);
                }; // 需要把图片赋值
                img.src = _URL.createObjectURL(file);
            });
        },
        //删除图片
        deleteImg(type, index) {
            if (!this.mulvaltipleSelection.length && !type) {
                this.$message.warning("还没选择哦!");
                return;
            }

            if (type == 1) {
                this.fileListImg.splice(index, 1);
                return;
            }

            this.mulvaltipleSelection.forEach((res) => {
                this.tableData.list.splice(
                    this.tableData.list.findIndex((i) => i.id == res.id),
                    1
                );
            });
            this.axios
                .post(
                    "order/v1/purchase/supplier/delPurchaseSupplier",
                    this.mulvaltipleSelection.map((res) => res.id),
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    if (res.code == 0) {
                        this.listAxios();
                        this.$message.success("删除成功");
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        exports() {
            this.loading = true;
            const exportParams = {
                sysUserId: sessionStorage.getItem('user_id') ? parseInt(sessionStorage.getItem('user_id')) : null,
                platformType: this.queryForm.platformType || 0,
                status: this.queryForm.info,
                returnOrderItem: this.queryForm.brand,
                purchaseType: this.queryForm.founder,
                supplierName: this.queryForm.supplierName,
                // 添加分类筛选参数
                categoryType: this.queryForm.categoryType,
                categoryValue: this.queryForm.categoryValue,
                returnerId: this.queryForm.receivers && this.queryForm.receivers.length > 0
                    ? this.queryForm.receivers.map(user => user.id)
                    : null
            };
            this.$api.srmReturnOrderExport(exportParams).then((res) => {
                this.loading = false;
                if (res.code == 0) {
                    this.downloadlink(res.data)
                } else {
                    this.$message.error(res.message);
                }

            })
        },
        moreProdMaterial(e) {
            this.moreProdMaterialText = e;
            this.isMoreProdMaterial = true;
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.listAxios();
        },
        handleCurrentChange(e) {
            this.page.currentPage = e;
            this.listAxios();
        },
        listAxios() {
            // 从localStorage获取用户ID，确保不为空
            const sysUserId = sessionStorage.getItem('user_id') || '';
            console.log('从localStorage获取的user_id:', sysUserId);

            // 构建查询参数
            const params = {
                pageNo: this.page.currentPage,
                pageSize: this.page.pageSize,
                sysUserId: sysUserId ? parseInt(sysUserId) : null,
                platformType: this.queryForm.platformType || 0,
                status: this.queryForm.info,
                returnOrderItem: this.queryForm.brand,
                purchaseType: this.queryForm.founder,
                supplierName: this.queryForm.supplierName,
                purchaseOrderNo: this.queryForm.purchaseOrderNo,
                returnerId: this.queryForm.returnerId
            };

            // 根据搜索类型动态添加搜索条件
            if (this.queryForm.searchType && this.queryForm.searchKeyword) {
                if (this.queryForm.searchType === 'returnOrderNo') {
                    params.returnOrderNo = this.queryForm.searchKeyword;
                } else if (this.queryForm.searchType === 'purchaseOrderNo') {
                    params.purchaseOrderNo = this.queryForm.searchKeyword;
                }
            }

            this.$api.srmReturnOrderPage(params).then((res) => {
                if (res.code == 0) {
                    this.tableData.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                } else {
                    this.$message.error(res.message);
                }
            }).catch(err => {
                console.error('请求失败:', err);
            });
        },
        // 创建人下拉框
        upplierAxios() {
            this.axios
                .get("/order/v1/purchase/supplier/supplierCreatedByList")
                .then((res) => {
                    if (res.code == 0) {
                        this.upplier = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },

        // 查看图片
        seeImg(row) {
            if (row.supplierImage.split(',')[0]) {
                this.moreImg = row.supplierImage;
                this.imgDialogVisible = true;
            }
        },

        reset() {
            this.queryForm = {
                info: "",
                supplierName: "",
                founder: "",
                address: "",
                brand: "",
                date: "",
                searchType: "returnOrderNo", // 重置为默认值
                searchKeyword: "", // 清空搜索关键词
                receivers: [],
                returnerId: null,
            };
            this.tableData.pageNo = 1;
            this.tableData.pageSize = 10;
            this.listAxios();
        },
        // 搜索事件
        searchEvent() {

            // 构建查询参数
            const params = {
                // 将分类类型和值组合成一个参数传递给后端
                category: this.queryForm.categoryType && this.queryForm.categoryValue
                    ? `${this.queryForm.categoryType}:${this.queryForm.categoryValue}`
                    : '',
            };
            this.tableData.pageNo = 1;
            this.tableData.pageSize = 10;
            // this.listAxios();
            this.listAxios(params);
        },
        // 停用供应商
        stopEvent: _.debounce(function (id, index) {
            let ats = [];
            ats.push(id);
            this.$confirm("确定停用该供应商, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.axios
                        .post("/order/v1/purchase/supplier/confirmPurchaseSupplier", {
                            ids: ats,
                            supplierStatus: 1,
                        })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: "success",
                                    message: "停用成功!",
                                });
                                // this.tableData.list.splice(index, 1);
                                this.listAxios();
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        }, 300),
        //** 品牌下拉 **//
        brandSelectBox() {
            const params = { pageNo: 1, pageSize: 999 }
            this.$api.brandCommList(params).then((res) => {
                this.brandselect = res.data.list
            }).catch((err) => {
                console.log(err)
            })
            // this.axios.get("/order/comm/commodity/selectList").then((res) => {
            //   //console.log('分类')
            //   //console.log(res);
            //   if (res.code == 0) {
            //     this.brandselect = res.data;
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
        },
        //** 品牌下拉 **//
        // 分类下拉框
        brandSelect() {
            this.axios.get("/order/comm/commodity/selectBrand").then((res) => {
                if (res.code == 0) {
                    this.options = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        addCg() {
            let array = [];
            if (this.mulvaltipleSelection.length > 0) {
                for (let i in this.mulvaltipleSelection) {
                    array.push(this.mulvaltipleSelection[i].id);
                }

                this.$router.push({
                    name: "purchasingAdd",
                    query: {
                        ids: JSON.stringify(array),
                    },
                });
            } else {
                this.$message.warning("未选择供应商");
            }
        },
    },
};
</script>

<style scoped lang="scss">
.btnBox {
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    margin: 0 -10px;

    /deep/ {
        .el-form-item__content {

            line-height: 1;
        }

        .el-input-group__prepend {
            width: 90px;
            padding: 0 12px 0 10px;
            box-sizing: border-box;

            // font-family: PingFang SC;
            // font-weight: 400;
            .el-input__inner {
                padding: 0 10px 0 7px;
                text-align: left;
            }
        }

        .el-input__inner {
            padding: 0 8px 0;
            height: 24px;
            line-height: 24px;
            border-radius: 0;
            margin-bottom: 8px;
            width: 120px;

        }

        .group-con-form {

            .el-input--mini,
            .el-cascader--mini {
                width: 180px;
            }

            .el-input__inner {
                text-align: left;
                padding: 0 10px 0 8px;
                max-width: 180px;
            }
        }
    }
}

/* 下拉框组样式 */
.input-with-select {
    display: flex;
    align-items: center;

    .prepend-text {
        width: 110px;
        flex-shrink: 0;
        background-color: #F5F7FA;
        border: 1px solid #DCDFE6;
        border-right: none;
        font-size: 12px;
        color: #909399;
        font-family: Arial;
        height: 24px;
        line-height: 22px;
        box-sizing: border-box;
        padding: 0 0 0 6px;
        border-radius: 4px 0 0 4px;
    }

    .category-select {
        ::v-deep .el-input__inner {
            font-weight: 400;
            font-size: 12px;
            color: #7F7F7F;
            width: 110px;
            border-radius: 0;
            border-right: none;
            background-color: #F5F7FA;
            height: 24px;
            line-height: 24px;
        }

        ::v-deep .el-select__caret {
            line-height: 24px;
        }
    }

    .value-select {
        ::v-deep .el-input__inner {
            border-radius: 0 4px 4px 0;
            background-color: #F5F7FA;
            height: 24px;
            line-height: 24px;
        }

        ::v-deep .el-select__caret {
            line-height: 24px;
        }
    }
}

/* 选项文本溢出时显示省略号 */
.category-option,
.value-option {
    ::v-deep .el-select-dropdown__item {
        span {
            font-weight: 400;
            font-size: 12px;
            color: #7F7F7F;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.form-buttons {
    /deep/ .el-form-item__content {
        width: 100%;
    }
}

.button-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;

}

.button-group {
    display: flex;
    gap: 10px;
    align-items: center;

    &.left-group {
        justify-content: flex-start;

        .el-button {
            height: 24px;
            padding: 0 12px;
            line-height: 22px;
            font-size: 12px;

            &.is-plain {
                background-color: #ffffff;
            }
        }
    }

    &.right-group {
        justify-content: flex-end;

        .el-checkbox {
            margin-bottom: 0;

            .el-checkbox_label {
                font-size: 12px;
                color: #606266;
            }
        }
    }
}

// 确保表单项不会额外增加间距
.btnBox /deep/ .el-form-item {
    margin-bottom: 8px;
}

// 特别针对按钮表单项进行调整
.form-buttons /deep/ .el-form-item__content {
    line-height: normal;
}

/deep/.cell {
    color: #333;
}

.page {
    text-align: right;
    width: 100%;
    background: #f5f5f5;
    padding-right: 20px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 1000;

    span {
        font-size: 14px;
        color: #666;
        display: inline-block;
        margin-left: 10px;
    }

    .el-pagination {
        display: inline-block;
        vertical-align: middle;
    }
}

.add_supplier {
    /deep/ {
        .el-dialog__title {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
        }
    }
}

.supplier {
    margin-top: 20px;

    /deep/.el-form-item__label {
        width: 100px;
        height: 30px;
        line-height: 30px;
    }

    /deep/.el-input,
    /deep/.el-input__inner {
        height: 30px;
        line-height: 30px;
    }

    /deep/.el-form-item {
        margin-bottom: 15px;
    }

    /deep/ {
        .el-textarea {
            width: 100%;
        }
    }

    /deep/.el-select {
        width: 100%;

        /deep/.el-input__icon {
            height: 30px;
            line-height: 30px;
        }
    }
}

.opt {
    color: rgb(65, 104, 231);
}

.opt:hover {
    cursor: pointer;
}

/deep/.el-dialog__body {
    padding: 0 25px;
}
</style>
<style lang="scss" scoped>
.input-with-select {
    display: flex;
    align-items: center;

    .prepend-text {
        width: 110px;
        flex-shrink: 0;
        background-color: #F5F7FA;
        border: 1px solid #DCDFE6;
        border-right: none;
        font-size: 12px;
        color: #909399;
        font-family: Arial;
        height: 24px;
        line-height: 22px;
        box-sizing: border-box;
        padding: 0 0 0 6px;
    }

    .select {
        border-radius: 0;
        line-height: 24px;

        .el-input__inner {
            border-radius: 0;
            padding: 0 8px 0 0;
            font-size: 12px;
            font-family: Arial;
            height: 24px !important;
        }

        .el-input__suffix {
            display: none;
        }

        .el-cascader__tags {
            flex-wrap: nowrap;
            cursor: pointer;
            justify-content: flex-end;
            right: 3px;

            .el-tag {
                margin: 0;
                padding: 0 1px;
                height: 18px;
                max-width: calc(100% - 3px);
                // background-color: #fff;
            }

            .el-tag__close {
                display: none;
            }
        }
    }

    // .select-one .el-cascader__tags{

    // }
    .select-two .el-cascader__tags {
        .el-tag {
            max-width: calc(100% - 25px);
            // margin-right: 2px;
        }

        .el-tag:last-child {
            // letter-spacing: -1px;
            margin-left: 2px;

            & span::first-letter {
                margin-right: -2px;
            }
        }
    }

    .select-ten .el-cascader__tags {
        .el-tag {
            max-width: calc(100% - 32px);
        }
    }
}
</style>